import React from "react";
import { Tag } from "antd";

const TagItem = (props) => {
  const { label, closable, onClose } = props;
  return (
    <Tag
      color='#63b3ed'
      // color='processing'
      closable={closable}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "0.8rem",
        padding: "0.2rem 0.5rem",
        borderRadius: "0.5rem",
        margin: "0.2rem",
      }}
    >
      {label}
    </Tag>
  );
};

export default TagItem;
